import { GcpBox, GcpDateRangePicker, GcpTypography } from '@back-office/ui';
import { Button, Dialog, Divider, IconButton } from '@material-ui/core';
import makeStyles from '@material-ui/core/styles/makeStyles';
import CloseIcon from '@material-ui/icons/Close';
import { DateRange } from '@material-ui/pickers';
import { observer } from 'mobx-react';
import React, { FC, MouseEvent } from 'react';
import { useTranslation } from 'react-i18next';
import useViewModel from './viewmodel';

const useStyles = makeStyles((theme) => ({
  icon: {
    fill: theme.palette.common.mineShaft,
  },
}));

export interface Store {
  date: DateRange<Date>;
  openCalendar: boolean;
  handleOnChangeDatePicker: (date: DateRange<Date>) => void;
  handleOnClickDatePicker: () => void;
  handleOnCloseDatePicker: () => void;
  handleOnClear: (event: MouseEvent<HTMLOrSVGElement>) => void;
  handleOnExport: () => void;
  handleClose: (event: MouseEvent<HTMLOrSVGElement>, reason: string) => void;
}

interface ExportToCsvDialogProps {
  open: boolean;
  handleOnClose: () => void;
}

const ExportToCsvDialog: FC<ExportToCsvDialogProps> = observer((props) => {
  const { t } = useTranslation();
  const classes = useStyles();
  const { open, handleOnClose } = props;
  const { state } = useViewModel(handleOnClose);

  return (
    <Dialog
      fullWidth
      aria-labelledby="export-to-csv-dialog"
      open={open}
      onClose={state.handleClose}
    >
      <GcpBox
        alignItems="center"
        display="flex"
        justifyContent="space-between"
        ml={3}
      >
        <GcpTypography variant="h3">
          {t('transaction_list.export')}
        </GcpTypography>
        <IconButton aria-label="Close" onClick={state.handleOnClear}>
          <CloseIcon className={classes.icon} />
        </IconButton>
      </GcpBox>
      <Divider />
      <GcpBox mb={3} ml={3} mr={3} mt={3}>
        <GcpBox>
          <GcpTypography
            paint="mineShaft"
            size={14}
            variant="body1"
            weight={500}
          >
            {t('transaction_list.select_date')}
          </GcpTypography>
        </GcpBox>
        <GcpBox mt={1}>
          <GcpDateRangePicker
            disableFuture
            fullWidth
            date={state.date}
            handleOnChange={state.handleOnChangeDatePicker}
            handleOnClear={state.handleOnClear}
            handleOnClick={state.handleOnClickDatePicker}
            handleOnClose={state.handleOnCloseDatePicker}
            openCalendar={state.openCalendar}
          />
        </GcpBox>
        <GcpBox mt={1}>
          <GcpTypography paint="silver" size={12} variant="body1">
            {t('transaction_list.caution')}
          </GcpTypography>
        </GcpBox>
      </GcpBox>
      <Divider />
      <GcpBox
        display="flex"
        justifyContent="flex-end"
        mb={1}
        ml={3}
        mr={3}
        mt={1}
      >
        <Button
          color="primary"
          size="large"
          type="button"
          variant="contained"
          onClick={state.handleOnExport}
        >
          {t('transaction_list.exports')}
        </Button>
      </GcpBox>
    </Dialog>
  );
});

export default ExportToCsvDialog;
